import type { ParsedUrlQuery } from 'querystring'

import ROUTES from '~/shared/constants/routes.const'

/** Marks a funnel entry from outside so the funnel restarts at its first step. */
export const GET_STARTED_ENTRY_PARAM = 'fresh'

export const GET_STARTED_ENTRY_QUERY = { [GET_STARTED_ENTRY_PARAM]: 'true' }

// Only for consumers taking a string href. Next encodes a URL object's `pathname`, so this string
// placed there navigates to "/get-started/intro%3Ffresh=true" and 404s — use GET_STARTED_ENTRY_URL.
export const GET_STARTED_ENTRY_ROUTE = `${ROUTES.GET_STARTED_INTRO}?${GET_STARTED_ENTRY_PARAM}=true`

/** The same destination split the way Next's URL objects expect. */
export const GET_STARTED_ENTRY_URL = { pathname: ROUTES.GET_STARTED_INTRO, query: GET_STARTED_ENTRY_QUERY }

/**
 * The query to carry across a funnel hop. Every step used to push a bare path, so ?partner, utm_*
 * and anything else ended at the first navigation off /get-started/intro — which is why the partner
 * needs sessionStorage, and why traffic_source (rebuilt per event from window.location.search in
 * analyticsBQ) went blank from signup onwards.
 *
 * `fresh` is the one thing dropped: it marks the start of a run, and by the time we navigate the
 * run has started. Carrying it would restart the funnel on every hop.
 */
export const carryFunnelQuery = (query: ParsedUrlQuery): ParsedUrlQuery =>
  Object.fromEntries(Object.entries(query).filter(([key]) => key !== GET_STARTED_ENTRY_PARAM))
